import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-customer-engagement",
  templateUrl: "./customer-engagement.component.html",
  styleUrls: ["./customer-engagement.component.scss"],
})
export class CustomerEngagementComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);

    $('.float-nav').click(function () {
      $('.float-main-nav, .menu-btn').toggleClass('active');
    });
  }
}
